"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_PAYMENT_MODE = exports.SET_PAYMENT_METHOD_CONST = exports.PAYMENT_CONFIRMATION_V3 = exports.PAYMENT_CONFIRMATION = exports.LIST_OF_COUPON = exports.EPHARMACY_INITIATE_PAYMENT = exports.DELETE_COUPON = exports.CREATE_ORDER = exports.APPLIED_COUPON = void 0;
const APPLIED_COUPON = exports.APPLIED_COUPON = 'appliedCoupon';
const DELETE_COUPON = exports.DELETE_COUPON = 'deleteCoupon';
const LIST_OF_COUPON = exports.LIST_OF_COUPON = 'listOfCoupon';
const EPHARMACY_INITIATE_PAYMENT = exports.EPHARMACY_INITIATE_PAYMENT = 'initiatePayment';
const PAYMENT_CONFIRMATION = exports.PAYMENT_CONFIRMATION = 'PaymentConfirmation';
const PAYMENT_CONFIRMATION_V3 = exports.PAYMENT_CONFIRMATION_V3 = 'PaymentConfirmationV3';
const SET_PAYMENT_METHOD_CONST = exports.SET_PAYMENT_METHOD_CONST = 'setPaymentMethod';
const CREATE_ORDER = exports.CREATE_ORDER = 'createOrder';
const SET_PAYMENT_MODE = exports.SET_PAYMENT_MODE = 'setPaymentMode';